import { render, staticRenderFns } from "./BottomNews.vue?vue&type=template&id=e39a60ae&scoped=true"
import script from "./BottomNews.vue?vue&type=script&lang=js"
export * from "./BottomNews.vue?vue&type=script&lang=js"
import style0 from "./BottomNews.vue?vue&type=style&index=0&id=e39a60ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39a60ae",
  null
  
)

export default component.exports